import { Flex, Heading, Tooltip } from "@chakra-ui/react";
import { StandaloneMenuProps } from "../../../types/sidebar-v2.type";
import JGoogleIcon from "../../JGoogleIcon/JGoogleIcon";
import { NavLink } from 'react-router-dom'
import useSidebarV2 from "../useSidebarV2";
import sidebarV2Store from "../../../stores/sidebar-v2.store";
import { headingTheme } from "../../../theme/components";
import NewFeatureTag from "./NewFeatureTag";

interface MenuComponentProps {
  standaloneMenu: StandaloneMenuProps
}

export default function Menu(props: MenuComponentProps) {
  const { standaloneMenu } = props

  const { textColor, searchBarBackgroundColor } = useSidebarV2()
  const { reveal } = sidebarV2Store()

  const menuContent = (
    <>
      <Tooltip
        label={standaloneMenu.label}
        aria-label={standaloneMenu.label}
        placement='right'
        isDisabled={reveal}
        hasArrow
        {...headingTheme.sizes.chakra_label_large}
        backgroundColor='onBackground'
        color='background'
      >
        <Flex marginX={reveal ? 'unset' : 'auto'}>
          <JGoogleIcon
            name={standaloneMenu.icon}
            fontSize='24px'
            color={textColor}
          />
        </Flex>
      </Tooltip>
      <Heading
        size='chakra_label_large'
        color={textColor}
        display={reveal ? 'block' : 'none'}
      >{standaloneMenu.label}</Heading>
      {standaloneMenu.isNew && reveal
        ? <NewFeatureTag />
        : null
      }
    </>
  )

  if (standaloneMenu.isExternal) {
    return (
      <Flex
        as='a'
        href={standaloneMenu.href}
        target='_blank'
        rel='noopener noreferrer'
        padding='4px'
        alignItems='center'
        gap='4px'
        borderRadius='8px'
      >
        {menuContent}
      </Flex>
    )
  }

  return (
    <Flex
      as={NavLink}
      end
      to={standaloneMenu.href}
      padding='4px'
      alignItems='center'
      gap='4px'
      borderRadius='8px'
      _activeLink={{
        backgroundColor: searchBarBackgroundColor
      }}
    >
      {menuContent}
    </Flex>
  )
}
